<template>
  <div>
    <PageAllow controller="Logistics" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherKeyword
                v-model="options.logistics_name"
                @text="KeyWord = $event"
                :label="$t('LogisticsSetting.select')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                small
                color="primary"
                class="ms-1"
                @click="
                  Dialog = true;
                  mode = 'new';
                "
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("LogisticsSetting.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="logistics"
          :loading="loading"
          :options.sync="options"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>

          <template v-slot:item.actions="{ item }">
            <!-- 编辑 -->
            <v-btn
              small
              dark
              color="action"
              class="px-2 me-2 mb-1"
              @click.stop="
                currentItem = JSON.parse(JSON.stringify(item));
                kdn_data =
                  item.kdn_data == null
                    ? {}
                    : JSON.parse(JSON.stringify(item.kdn_data));
                Dialog = true;
                mode = 'edit';
              "
            >
              {{ $t("LogisticsSetting.actions.edit") }}
            </v-btn>
            <!-- 隐藏 -->
            <v-btn
              v-if="
                $permission.permissionAllow('Logistics', 'delete') &&
                !item.delete_flg
              "
              small
              dark
              color="danger"
              class="px-2 me-2 mb-1"
              @click.stop="
                delId = item.id;
                Del();
              "
            >
              {{ $t("LogisticsSetting.actions.delete") }}
            </v-btn>
            <!-- 显示 -->
            <v-btn
              v-if="
                $permission.permissionAllow('Logistics', 'delete') &&
                item.delete_flg
              "
              small
              dark
              color="primary"
              class="px-2 me-2 mb-1"
              @click.stop="
                delId = item.id;
                Del();
              "
            >
              {{ $t("LogisticsSetting.actions.undelete") }}
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <v-dialog v-model="Dialog" width="680px">
      <v-card>
        <v-card-title class="mx-3">
          <v-spacer></v-spacer>
          {{ $t("LogisticsSetting.info") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="Dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.logistics_name") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line v-model="currentItem.logistics_name">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.linkman") }}
                {{ $t("Global.colon") }}
                <Required :show="true" :mode="mode" />
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line dense v-model="currentItem.linkman">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.contact_method") }}
                {{ $t("Global.colon") }}
                <!-- <Required :show="true" :mode="mode" /> -->
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  dense
                  v-model="currentItem.contact_method"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.rank") }}
                {{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  dense
                  v-model="currentItem.rank"
                  type="number"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              align="center"
              v-if="
                $permission.permissionAllow(
                  'StockShelve',
                  'kdnCallExpressPrint'
                ) && push_logistics_form == 2002
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.CustomerName") }}
                {{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  dense
                  v-model="kdn_data.customer_name"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              align="center"
              v-if="
                $permission.permissionAllow(
                  'StockShelve',
                  'kdnCallExpressPrint'
                ) && push_logistics_form == 2002
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.CustomerPwd") }}
                {{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line dense v-model="kdn_data.customer_pwd">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              align="center"
              v-if="
                $permission.permissionAllow(
                  'StockShelve',
                  'kdnCallExpressPrint'
                ) && push_logistics_form == 2002
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.SendSite") }}
                {{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line dense v-model="kdn_data.send_site">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              align="center"
              v-if="
                $permission.permissionAllow(
                  'StockShelve',
                  'kdnCallExpressPrint'
                ) && push_logistics_form == 2002
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.SendStaff") }}
                {{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line dense v-model="kdn_data.send_staff">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              align="center"
              v-if="
                $permission.permissionAllow(
                  'StockShelve',
                  'kdnCallExpressPrint'
                ) && push_logistics_form == 2002
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.MonthCode") }}
                {{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field single-line dense v-model="kdn_data.month_code">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              align="center"
              v-if="
                $permission.permissionAllow(
                  'StockShelve',
                  'kdnCallExpressPrint'
                ) && push_logistics_form == 2002
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.TemplateSize") }}
                {{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  dense
                  v-model="kdn_data.template_size"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              align="center"
              v-if="
                $permission.permissionAllow(
                  'StockShelve',
                  'kdnCallExpressPrint'
                ) && push_logistics_form == 2002
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.DeliveryMethod") }}
                {{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  single-line
                  dense
                  v-model="kdn_data.delivery_method"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              align="center"
              v-if="
                $permission.permissionAllow(
                  'StockShelve',
                  'kdnCallExpressPrint'
                ) && push_logistics_form == 2002
              "
            >
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("LogisticsSetting.Fields.type") }}
                {{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-autocomplete
                  color="primary"
                  v-model="kdn_data.express_type"
                  :items="typeItems"
                  item-value="text"
                >
                </v-autocomplete>
                <span class="red--text">
                  {{ $t("LogisticsSetting.hint") }}
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="Dialog = false">
            {{ $t("SubAccount.Fields.cancel") }}
          </v-btn>
          <v-btn color="primary" depressed @click="submit()">
            {{ $t("SubAccount.Fields.submit") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import Logistics from "@/api/logistics";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Required from "@/components/plugins/Required";
import Settings from "@/api/settings";

const defaultOptions = {
  logistics_name: "",
};

export default {
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    logistics: [],
    currentItem: {},
    kdn_data: {},
    delDialog: false,
    Dialog: false,
    mode: "",
    delId: null,
    deleteLogistics: {},
    push_logistics_form: null,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    Required,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("SettingNav.logisticsSetting"),
        disabled: true,
        href: "/settings/logistics-setting",
      },
    ],
    typeItems: () => [
      {
        text: i18n.t("LogisticsSetting.types.normal"),
      },
      {
        text: i18n.t("LogisticsSetting.types.vip"),
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("LogisticsSetting.Fields.logistics_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "logistics_name",
        },
        {
          text: i18n.t("LogisticsSetting.Fields.linkman"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "linkman",
        },
        {
          text: i18n.t("LogisticsSetting.Fields.contact_method"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "contact_method",
        },
        {
          text: i18n.t("LogisticsSetting.Fields.rank") + i18n.t("Global.brackets", [i18n.t("stockRoadway.Fields.on")]),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "rank",
        },
        {
          text: i18n.t("LogisticsSetting.Fields.actions"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "actions",
        },
      ];
    },

    ...mapState(["loading", "stickTableCols"]),
  },

  mounted() {
    this.getLogisticsFromAPI();
    Settings.getSettings({
      keys: ["push_logistics_form"],
    }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.push_logistics_form = response.data.settings.push_logistics_form;
        }
      }.bind(this)
    );
  },

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        logistics_name: this.KeyWord,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },

    getLogisticsFromAPI() {
      Logistics.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.logistics = response.data.logistics;
          }
        }.bind(this)
      );
    },
    // 新增和编辑的提交
    submit() {
      var data = Object.assign({}, this.currentItem, {
        kdn_data: this.kdn_data,
      });
      if (this.mode == "new") {
        Logistics.add(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.Dialog = false;
              this.getLogisticsFromAPI();
            }
          }.bind(this)
        );
      } else if (this.mode == "edit") {
        Logistics.edit(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.Dialog = false;
              this.getLogisticsFromAPI();
            }
          }.bind(this)
        );
      }
    },
    Del() {
      Logistics.Delete(this.delId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.deleteLogistics = response.data.logistic;
            this.getLogisticsFromAPI();
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getLogisticsFromAPI();
      },
    },
    Dialog: {
      handler() {
        if (!this.Dialog) {
          this.currentItem = {};
          this.kdn_data = {};
        }
      },
    },
  },
};
</script>

<style>
</style>